import type { TFunction } from 'i18next';
import type { CognitiveFitness } from '../../model';
import type { AssessmentResultItemDataFragment, NBackReportDataFragment } from '@/gql/graphql';
import { formatDecimalValue } from '@/utils/common';

const parseNBack = (t: TFunction, items: AssessmentResultItemDataFragment[]): CognitiveFitness | null => {
    const item = items.find(i => i.result.__typename === 'NBackResult');
    const mi = item?.moduleInstance;
    const r = item?.result as NBackReportDataFragment;
    if (!mi?.name || !r) {
        return null;
    }

    return {
        name: mi.name ?? '',
        moduleDefinitionIdentifier: mi.moduleDefinitionIdentifier ?? '',
        description: mi.description ?? '',
        result: [
            {
                label: t('traineeReports:performance.cognitiveFitness.scoreLabel'),
                value: `${formatDecimalValue(r.accuracy ?? 0)}/100`,
            },
            {
                label: t('traineeReports:performance.cognitiveFitness.avgResponseTimeMs'),
                value: r.meanHitRtMs.toFixed(2),
            },
            {
                label: t('traineeReports:performance.cognitiveFitness.dPrime'),
                value: r.dPrime.toFixed(2),
            },
        ],
    };
};

export default parseNBack;
